import React from 'react';
import backgroundImage from '../images/pillars.jpeg'; 

function OurPillars() {
  const pageStyle = {
    backgroundColor: '#5a84c4ff',
    margin: 0,
    padding: 0,
  };

  const containerStyle = {
    minHeight: '100vh',
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'contain', // ✅ Show full image
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top center',
    padding: '60px 20px',
    display: 'flex',
    justifyContent: 'center',
  };

  const overlayStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    padding: '40px',
    borderRadius: '10px',
    maxWidth: '900px',
    width: '100%',
    color: '#004080',
    textAlign: 'left',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
  };

  const headingStyle = {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    marginBottom: '2rem',
    textAlign: 'center',
  };

  const valueStyle = {
    fontSize: '1.25rem',
    fontWeight: 'bold',
    marginBottom: '1rem',
    lineHeight: '1.6',
  };

  return (
    <div style={pageStyle}>
      <div style={containerStyle}>
        <div style={overlayStyle}>
          <h1 style={headingStyle}>School's Ethos</h1>

          <p style={valueStyle}>
            1. <strong>Respect:</strong> We nurture a culture of mutual respect among students, staff, and the community.
          </p>
          <p style={valueStyle}>
            2. <strong>Integrity:</strong> We encourage honesty and strong moral principles in all actions.
          </p>
          <p style={valueStyle}>
            3. <strong>Kindness and Compassion:</strong> We promote empathy and care for others, fostering a supportive environment.
          </p>
          <p style={valueStyle}>
            4. <strong>Curiosity and Love of Learning:</strong> We inspire students to ask questions and embrace lifelong learning.
          </p>
          <p style={valueStyle}>
            5. <strong>Inclusivity and Diversity:</strong> We celebrate differences and create a welcoming environment for all.
          </p>
          <p style={valueStyle}>
            6. <strong>Responsibility:</strong> We teach students to take ownership of their actions and contribute positively.
          </p>
          <p style={valueStyle}>
            7. <strong>Creativity and Innovation:</strong> We encourage creative thinking and problem-solving.
          </p>
          <p style={valueStyle}>
            8. <strong>Collaboration and Teamwork:</strong> We emphasize working together to achieve common goals.
          </p>
          <p style={valueStyle}>
            9. <strong>Perseverance and Resilience:</strong> We foster grit and determination to overcome challenges.
          </p>
          <p style={valueStyle}>
            10. <strong>Safety and Wellbeing:</strong> We prioritize a safe, healthy, and supportive space for every child.
          </p>
        </div>
      </div>
    </div>
  );
}

export default OurPillars;
